/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CommentReplyType } from './CommentReplyType';
import { CommentType } from './CommentType';
const BaseCommentReplyParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['inReplyToId', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'in_reply_to_id'],
    ['lastEdit', /* #__PURE__ */ parsers.maybeNull(parsers.moment), 'last_edit'],
    ['createdAt', parsers.moment, 'created_at'],
    ['replyType', CommentReplyType, 'reply_type'],
    ['commentType', CommentType, 'comment_type'],
    ['approved', codecBoolean],
    ['commentBaseId', codecNumber, 'comment_base_id'],
]));
export class BaseCommentReply extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseCommentReplyParser.decode(input).map(res => new BaseCommentReply(res));
    }
    static unsafeDecode(input) {
        return BaseCommentReply.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCommentReplyParser.encode(data);
    }
    static schema() {
        return BaseCommentReplyParser.schema();
    }
}
